import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, vModelSelect as _vModelSelect, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "header-sub"
}
const _hoisted_4 = { class: "calificaciones-grid" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "cal-error-msg"
}
const _hoisted_7 = { class: "range-bar" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "cal-error-msg"
}
const _hoisted_10 = { class: "range-bar" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "cal-error-msg"
}
const _hoisted_13 = { class: "range-bar" }
const _hoisted_14 = {
  key: 0,
  class: "opinion-panel"
}
const _hoisted_15 = {
  key: 0,
  class: "opinion-vacio"
}
const _hoisted_16 = {
  key: 0,
  class: "persona-filtro"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "resp-grupo-titulo" }
const _hoisted_19 = { class: "op-badge" }
const _hoisted_20 = {
  key: 0,
  class: "opinion-vacio"
}
const _hoisted_21 = { class: "persona-head-op" }
const _hoisted_22 = { class: "persona-nombre-op" }
const _hoisted_23 = {
  key: 0,
  class: "persona-email-op"
}
const _hoisted_24 = {
  key: 1,
  class: "persona-fecha-op"
}
const _hoisted_25 = { class: "persona-resp-op" }
const _hoisted_26 = { class: "pr-enunciado-op" }
const _hoisted_27 = { class: "pr-valor-op" }
const _hoisted_28 = { class: "resultado-final" }
const _hoisted_29 = { class: "fila" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "fila" }
const _hoisted_32 = { class: "fila" }
const _hoisted_33 = { class: "fila" }
const _hoisted_34 = ["max"]
const _hoisted_35 = { class: "botones" }
const _hoisted_36 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useComponentes } from '@/store/GestionComponentes'
import useAutenticar from '@/store/IngresoAutenticar'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import type { RespuestasFormulario, RespuestaIndividual } from '@/interfaces/ConfiguracionInstrumento'
import {
  calcularCalificacionFinal,
  derivarGradoMaam,
  nivelClassMaam,
  pesosDesdeConfiguracion,
  PESOS_MAAM_DEFECTO,
  GRADOS_MAAM_DEFECTO,
  type PesosConsolidacion,
  type GradoMaam
} from '@/utils/consolidacion'
import {
  getConfiguracionVersionService,
  getGradosMaamService
} from '@/services/ConfiguracionEvaluacionService'

type CampoCal = 'calificacion_documental' | 'calificacion_cuantitativa' | 'calificacion_opinion'


export default /*@__PURE__*/_defineComponent({
  __name: 'EvaluacionIndividualView',
  setup(__props) {

/**
 * Calificación de UN indicador por UN evaluador.
 *
 * La nota final, el grado y el nivel los deriva el backend: lo que se envía son
 * las notas por dimensión. Una dimensión que no aplica se deja vacía, NO en cero
 * — la nota final se repondera sobre las presentes.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/indicador/:id_indicador/evaluar` (EvaluacionIndividual) — permiso `calificacion.calificar`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const router = useRouter()
const store = useGestionEvaluacionesIndicadores()
const indicadoresStore = useGestionIndicadores()
const componentesStore = useComponentes()
const authStore = useAutenticar()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const configOpinionStore = useGestionConfiguracionInstrumento()

// ── Feedback ──────────────────────────────────────────────────────────
const flotanteVisible = ref(false)
const flotanteMensaje = ref('')
const flotanteTipo = ref<'positivo' | 'error'>('positivo')
const exitoGuardado = ref(false)

function mostrarExito(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'positivo'
  exitoGuardado.value = true
  flotanteVisible.value = true
}
function mostrarError(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'error'
  exitoGuardado.value = false
  flotanteVisible.value = true
}
function onCerrarFlotante() {
  flotanteVisible.value = false
  if (exitoGuardado.value) {
    router.back()
  }
}

const idVersion = Number(route.params.id_version)
const idIndicador = Number(route.params.id_indicador)
const idUsuario = computed(() => authStore.usuarioActual?.id ?? null)
const nombreComponente = ref('')
const nombreIndicador = ref('')
const mismoNombre = computed(() =>
  !!nombreComponente.value &&
  !!nombreIndicador.value &&
  nombreComponente.value.trim() === nombreIndicador.value.trim()
)

const loading = ref(false)
const guardando = ref(false)
const esEdicion = ref(false)
const evaluacionId = ref<number | null>(null)
const camposEnEdicion = ref<CampoCal[]>([])
const hoy = new Date().toISOString().split('T')[0]

const form = ref({
  calificacion_documental: null as number | null,
  calificacion_cuantitativa: null as number | null,
  calificacion_opinion: null as number | null,
  observaciones: '',
  justificacion: '',
  fecha_evaluacion: hoy
})

const pesos = ref<PesosConsolidacion>({ ...PESOS_MAAM_DEFECTO })
const gradosMaam = ref<GradoMaam[]>([...GRADOS_MAAM_DEFECTO])

async function cargarConfiguracion() {
  const [cfgResult, gradosResult] = await Promise.all([
    getConfiguracionVersionService(idVersion),
    getGradosMaamService()
  ])
  if (cfgResult.ok && cfgResult.data) {
    pesos.value = pesosDesdeConfiguracion(cfgResult.data)
  } else {
    mostrarError('No se pudo cargar la configuración de pesos; se usan los valores MAAM por defecto.')
  }
  if (gradosResult.ok && gradosResult.data?.length) {
    gradosMaam.value = gradosResult.data
  }
}

// ── Validaciones y cálculos ───────────────────────────────────────────
function calFueraRango(campo: CampoCal): boolean {
  const v = form.value[campo]
  return v != null && (v < 0 || v > 5)
}

const hayCalFueraRango = computed(() =>
  calFueraRango('calificacion_documental') ||
  calFueraRango('calificacion_cuantitativa') ||
  calFueraRango('calificacion_opinion')
)

function clampCal(campo: CampoCal) {
  const v = form.value[campo]
  if (v == null) return
  if (v < 0) form.value[campo] = 0
  else if (v > 5) form.value[campo] = 5
}

function estaEnEdicion(campo: CampoCal): boolean {
  const tieneValor = form.value[campo] != null
  return !esEdicion.value || !tieneValor || camposEnEdicion.value.includes(campo)
}

function habilitarEdicion(campo: CampoCal) {
  if (!camposEnEdicion.value.includes(campo)) {
    camposEnEdicion.value = [...camposEnEdicion.value, campo]
  }
}

function pct(val: number | null): number {
  if (val == null || val < 0) return 0
  return Math.min((val / 5) * 100, 100)
}

function pct100(peso: number): number {
  return Math.round(peso * 100)
}

const calificacionFinal = computed(() =>
  calcularCalificacionFinal(
    form.value.calificacion_documental,
    form.value.calificacion_cuantitativa,
    form.value.calificacion_opinion,
    pesos.value
  )
)

const nivelDerivado = computed(() => {
  const tieneCalificacion =
    form.value.calificacion_documental != null ||
    form.value.calificacion_cuantitativa != null ||
    form.value.calificacion_opinion != null
  if (!tieneCalificacion) return '—'
  return derivarGradoMaam(calificacionFinal.value, gradosMaam.value)?.nombre ?? '—'
})

const nivelClass = computed(() => nivelClassMaam(calificacionFinal.value))

// ── Carga de datos ────────────────────────────────────────────────────
async function cargarEvaluacionExistente() {
  loading.value = true
  try {
    const params: { id_version: number; id_indicador: number; id_usuario?: number } = {
      id_version: idVersion,
      id_indicador: idIndicador,
    }
    if (idUsuario.value) params.id_usuario = idUsuario.value

    await store.cargar(params)
    const existente = store.evaluaciones[0]
    if (existente) {
      esEdicion.value = true
      evaluacionId.value = existente.id ?? null
      form.value.calificacion_documental = existente.calificacion_documental ?? null
      form.value.calificacion_cuantitativa = existente.calificacion_cuantitativa ?? null
      form.value.calificacion_opinion = existente.calificacion_opinion ?? null
      form.value.observaciones = existente.observaciones ?? ''
      form.value.justificacion = existente.justificacion ?? ''
      form.value.fecha_evaluacion = existente.fecha_evaluacion ?? hoy
    }
  } finally {
    loading.value = false
  }
}

async function cargarNombres() {
  const indicador = await indicadoresStore.cargarPorId(idIndicador)
  if (!indicador) return
  nombreIndicador.value = indicador.enunciado ?? indicador.nombre ?? ''

  await componentesStore.cargarPorId(indicador.id_componente)
  nombreComponente.value = componentesStore.componenteActual?.nombre ?? ''
}

async function guardarEvaluacion() {
  const d = form.value.calificacion_documental
  const c = form.value.calificacion_cuantitativa
  const o = form.value.calificacion_opinion

  if (d == null && c == null && o == null) {
    mostrarError('Ingrese al menos una calificación.')
    return
  }

  const fueraRango = [
    { campo: 'Documental', val: d },
    { campo: 'Cuantitativa', val: c },
    { campo: 'Opinión', val: o }
  ].filter(x => x.val != null && (x.val < 0 || x.val > 5))
  if (fueraRango.length) {
    mostrarError(`Calificación fuera del rango 0–5: ${fueraRango.map(x => x.campo).join(', ')}`)
    return
  }

  if (!form.value.fecha_evaluacion) {
    mostrarError('La fecha de evaluación es obligatoria.')
    return
  }

  guardando.value = true
  try {
    if (esEdicion.value && evaluacionId.value) {
      const result = await store.actualizar(evaluacionId.value, {
        calificacion_documental: d,
        calificacion_cuantitativa: c,
        calificacion_opinion: o,
        observaciones: form.value.observaciones || undefined,
        justificacion: form.value.justificacion || undefined
      })
      if (result.ok) {
        mostrarExito('Evaluación actualizada correctamente.')
      } else {
        const msgs = result.errors
          ? Object.values(result.errors).flat().join(' · ')
          : 'Error al actualizar. Revise los campos.'
        mostrarError(msgs)
      }
    } else {
      const result = await store.crearOActualizar({
        id_version: idVersion,
        id_indicador: idIndicador,
        id_usuario: idUsuario.value ?? 1,
        calificacion_documental: d,
        calificacion_cuantitativa: c,
        calificacion_opinion: o,
        observaciones: form.value.observaciones || null,
        justificacion: form.value.justificacion || null,
        fecha_evaluacion: form.value.fecha_evaluacion
      })
      if (result.ok) {
        const verb = result.status === 201 ? 'registrada' : 'actualizada'
        mostrarExito(`Evaluación ${verb} exitosamente.`)
        if (result.data?.id) evaluacionId.value = result.data.id
      } else {
        const msgs = result.errors
          ? Object.values(result.errors).flat().join(' · ')
          : 'Error al guardar. Revise los campos.'
        mostrarError(msgs)
      }
    }
  } finally {
    guardando.value = false
  }
}

// ── Instrumento de Opinión ────────────────────────────────────────────
const hayInstrumentoOpinion = ref(false)
const respuestasOpinion = ref<RespuestasFormulario[]>([])
const personaFiltradaOpinion = ref<string | null>(null)

const todosRespondientesOpinion = computed(() => {
  const vistos = new Set<string>()
  const lista: { google_response_id: string; label: string }[] = []
  for (const rf of respuestasOpinion.value) {
    for (const p of rf.respondientes ?? []) {
      if (!vistos.has(p.google_response_id)) {
        vistos.add(p.google_response_id)
        lista.push({
          google_response_id: p.google_response_id,
          label: p.nombre || p.email || 'Anónimo'
        })
      }
    }
  }
  return lista
})

function respuestasDePersonaOpinion(rf: RespuestasFormulario, responseId: string): RespuestaIndividual[] {
  return rf.respuestas.filter(r => r.google_response_id === responseId)
}

async function cargarInstrumentoOpinion() {
  await indicadorInstrumentoStore.getRelaciones()
  const relaciones = indicadorInstrumentoStore.relaciones.filter(r => r.id_indicador === idIndicador)
  for (const rel of relaciones) {
    await configOpinionStore.listar({ id_instrumento: rel.id_instrumento })
    if (configOpinionStore.configuraciones.length > 0) {
      hayInstrumentoOpinion.value = true
      const ultima = configOpinionStore.configuraciones[configOpinionStore.configuraciones.length - 1]
      await configOpinionStore.cargarRespuestas(ultima.id_configuracion)
      respuestasOpinion.value = [...configOpinionStore.respuestas]
      break
    }
  }
}

onMounted(() => {
  if (Number.isFinite(idVersion) && Number.isFinite(idIndicador)) {
    cargarConfiguracion()
    cargarEvaluacionExistente()
    cargarNombres()
    cargarInstrumentoOpinion()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value,
      message: "Cargando evaluación..."
    }, null, 8, ["visible"]),
    _createVNode(MensajeFlotante, {
      visible: flotanteVisible.value,
      mensaje: flotanteMensaje.value,
      tipo: flotanteTipo.value,
      onCerrar: onCerrarFlotante
    }, null, 8, ["visible", "mensaje", "tipo"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Evaluación Individual", -1)),
        (nombreComponente.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(nombreComponente.value), 1),
              (!mismoNombre.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(nombreIndicador.value), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, "Cancelar")
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "eval-form",
          onSubmit: _withModifiers(guardarEvaluacion, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["cal-card", { 'cal-card--error': calFueraRango('calificacion_documental') }])
            }, [
              _createElementVNode("label", null, "Calificación Documental (" + _toDisplayString(pct100(pesos.value.documental)) + "%)", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.calificacion_documental) = $event)),
                type: "number",
                min: "0",
                max: "5",
                step: "0.1",
                class: _normalizeClass(["cal-input", { 'input--error': calFueraRango('calificacion_documental'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_documental') }]),
                disabled: !estaEnEdicion('calificacion_documental'),
                placeholder: "0 - 5",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (clampCal('calificacion_documental')))
              }, null, 42, _hoisted_5), [
                [
                  _vModelText,
                  form.value.calificacion_documental,
                  void 0,
                  { number: true }
                ]
              ]),
              (calFueraRango('calificacion_documental'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "El valor debe estar entre 0 y 5"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "range-fill",
                  style: _normalizeStyle({ width: pct(form.value.calificacion_documental) + '%' })
                }, null, 4)
              ]),
              (!estaEnEdicion('calificacion_documental'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn guardar btn-cal-modificar",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (habilitarEdicion('calificacion_documental')))
                  }, " Modificar "))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["cal-card", { 'cal-card--error': calFueraRango('calificacion_cuantitativa') }])
            }, [
              _createElementVNode("label", null, "Calificación Cuantitativa (" + _toDisplayString(pct100(pesos.value.cuantitativa)) + "%)", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.calificacion_cuantitativa) = $event)),
                type: "number",
                min: "0",
                max: "5",
                step: "0.1",
                class: _normalizeClass(["cal-input", { 'input--error': calFueraRango('calificacion_cuantitativa'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_cuantitativa') }]),
                disabled: !estaEnEdicion('calificacion_cuantitativa'),
                placeholder: "0 - 5",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (clampCal('calificacion_cuantitativa')))
              }, null, 42, _hoisted_8), [
                [
                  _vModelText,
                  form.value.calificacion_cuantitativa,
                  void 0,
                  { number: true }
                ]
              ]),
              (calFueraRango('calificacion_cuantitativa'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "El valor debe estar entre 0 y 5"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "range-fill",
                  style: _normalizeStyle({ width: pct(form.value.calificacion_cuantitativa) + '%' })
                }, null, 4)
              ]),
              (!estaEnEdicion('calificacion_cuantitativa'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn guardar btn-cal-modificar",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (habilitarEdicion('calificacion_cuantitativa')))
                  }, " Modificar "))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["cal-card", { 'cal-card--error': calFueraRango('calificacion_opinion') }])
            }, [
              _createElementVNode("label", null, "Calificación de Opinión (" + _toDisplayString(pct100(pesos.value.opinion)) + "%)", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.calificacion_opinion) = $event)),
                type: "number",
                min: "0",
                max: "5",
                step: "0.1",
                class: _normalizeClass(["cal-input", { 'input--error': calFueraRango('calificacion_opinion'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_opinion') }]),
                disabled: !estaEnEdicion('calificacion_opinion'),
                placeholder: "0 - 5",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (clampCal('calificacion_opinion')))
              }, null, 42, _hoisted_11), [
                [
                  _vModelText,
                  form.value.calificacion_opinion,
                  void 0,
                  { number: true }
                ]
              ]),
              (calFueraRango('calificacion_opinion'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "El valor debe estar entre 0 y 5"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: "range-fill",
                  style: _normalizeStyle({ width: pct(form.value.calificacion_opinion) + '%' })
                }, null, 4)
              ]),
              (!estaEnEdicion('calificacion_opinion'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn guardar btn-cal-modificar",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (habilitarEdicion('calificacion_opinion')))
                  }, " Modificar "))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          (hayInstrumentoOpinion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "opinion-titulo" }, "Respuestas del instrumento de opinión", -1)),
                (!respuestasOpinion.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Sin respuestas registradas aún. "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (todosRespondientesOpinion.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "persona-filtro-label" }, "Filtrar por persona:", -1)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((personaFiltradaOpinion).value = $event)),
                              class: "persona-filtro-select"
                            }, [
                              _cache[15] || (_cache[15] = _createElementVNode("option", { value: null }, "— Todos —", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todosRespondientesOpinion.value, (r) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: r.google_response_id,
                                  value: r.google_response_id
                                }, _toDisplayString(r.label), 9, _hoisted_17))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, personaFiltradaOpinion.value]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(respuestasOpinion.value, (rf) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: rf.id_formulario_google,
                          class: "resp-grupo-op"
                        }, [
                          _createElementVNode("h4", _hoisted_18, [
                            _createTextVNode(_toDisplayString(rf.grupo_interes?.nombre ?? `Formulario ${rf.id_formulario_google}`) + " ", 1),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(rf.respondientes?.length ?? 0), 1)
                          ]),
                          (!rf.respondientes?.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Aún no hay respuestas en este grupo."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((personaFiltradaOpinion.value
                ? rf.respondientes?.filter(r => r.google_response_id === personaFiltradaOpinion.value)
                : rf.respondientes), (p) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: p.google_response_id,
                              class: "persona-card-op"
                            }, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("strong", _hoisted_22, _toDisplayString(p.nombre || p.email || 'Anónimo'), 1),
                                (p.nombre && p.email)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(p.email), 1))
                                  : _createCommentVNode("", true),
                                (p.respondido_at)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(p.respondido_at.substring(0, 10)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("ul", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(respuestasDePersonaOpinion(rf, p.google_response_id), (r) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: r.id_respuesta,
                                    class: "pr-item-op"
                                  }, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(r.enunciado), 1),
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(r.texto ?? r.valor ?? '—'), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "resultado-label" }, "Calificación Final (calculada)", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["resultado-valor", nivelClass.value])
            }, _toDisplayString(calificacionFinal.value.toFixed(2)), 3)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Nivel asignado (derivado de la rúbrica MAAM)", -1)),
            _createElementVNode("input", {
              value: nivelDerivado.value,
              class: "campo-readonly",
              readonly: "",
              disabled: ""
            }, null, 8, _hoisted_30)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[20] || (_cache[20] = _createElementVNode("label", null, [
              _createTextVNode("Observaciones "),
              _createElementVNode("span", { class: "opcional" }, "(opcional)")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.observaciones) = $event)),
              class: "campo-texto",
              rows: "3",
              placeholder: "Análisis técnico..."
            }, null, 512), [
              [_vModelText, form.value.observaciones]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "Justificación", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.justificacion) = $event)),
              class: "campo-texto",
              rows: "3",
              placeholder: "Soporte en evidencias..."
            }, null, 512), [
              [_vModelText, form.value.justificacion]
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Fecha de evaluación *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.fecha_evaluacion) = $event)),
              type: "date",
              class: "campo-fecha",
              max: _unref(hoy)
            }, null, 8, _hoisted_34), [
              [_vModelText, form.value.fecha_evaluacion]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn guardar",
              disabled: guardando.value || hayCalFueraRango.value
            }, _toDisplayString(guardando.value ? 'Guardando...' : (esEdicion.value ? 'Actualizar Evaluación' : 'Registrar Evaluación')), 9, _hoisted_36)
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})